export default "__VITE_ASSET__o_2nHIMW__"